/** @format */
import React from "react";
import { link } from "../link";

import { Link } from "react-router-dom";

import "../styles/categories.css";

function Categories({ gridCategories }) {
  return (
    <div className="grid-wrapper">
      {gridCategories.map((category) => {
        return (
          <Link
            key={category.id}
            to={`/${category.name}`}
            className={`grid-item  ${category.class}`}
          >
            <span className="title-cat">{category.name}</span>{" "}
          </Link>
        );
      })}
    </div>
  );
}

export default Categories;

{
  /* <Link to={`/${category.product_category}`}>
                <h3>{category.product_category}</h3>
              </Link> */
}
